/* eslint-disable prefer-rest-params */
/* istanbul ignore next */
function runGoogleTagManager(userId) {
  window.dataLayer ||= [];
  window.gtag = (...args) => {
    window.dataLayer.push(args);
  };

  window.gtag('js', new Date());

  window.gtag('config', 'AW-802776800');
  window.gtag('set', { user_id: userId });
  window.gtag('event', 'conversion', {
    send_to: 'AW-802776800/9xIlCO3gt4QBEODN5f4C'
  });

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-802776800';
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(script, firstScript);
}

export { runGoogleTagManager };
